const initial = {
  opacity: 0,
  y: "50",
};

const animate = {
  opacity: 1,
  y: 0,
  transition: {
    type: 'spring'
  }
}

export { initial, animate}